module.exports = __webpack_public_path__ + "static/media/entry-complete-background.cff88dc7.svg";